import React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { makePeerConsumerSelector } from "../../helpers/Selectors";
import PropTypes from "prop-types";
import VideoView from "./Media/VideoView";
import PeerInfo from "./Media/PeerInfo";
import MediaBox from "./Media/MediaBox";

const useStyles = makeStyles((theme) =>
  createStyles({
    videoInfo: {
      position: "absolute",
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.3)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: theme.spacing(1),
      borderRadius: 24,
      [theme.breakpoints.down("xs")]: {
        borderRadius: 0,
        padding: theme.spacing(0),
      },
      zIndex: 21,
      "& p": {
        padding: "6px 12px",
        borderRadius: 6,
        userSelect: "none",
        pointerEvents: "none",
        fontSize: 20,
        color: "rgba(255, 255, 255, 0.55)",
      },
    },
  })
);

const SpeakerPeer = ({ id, style, onFilmStrip = false, isMini = false }) => {
  const classes = useStyles();
  const meId = useSelector((state) => state.me.id);
  const peer = useSelector((state) => state.peers[id]);
  const room = useSelector((state) => state.room);
  const session = useSelector((state) => state.remoteControl);
  const getPeerConsumers = makePeerConsumerSelector();
  const { micConsumer, webcamConsumer, screenConsumer } = useSelector((state) =>
    getPeerConsumers(state, id)
  );

  if (!peer) return null;

  const videoVisible =
    Boolean(webcamConsumer) &&
    !webcamConsumer.locallyPaused &&
    !webcamConsumer.remotelyPaused;

  const screenVisible =
    Boolean(screenConsumer) &&
    !screenConsumer.locallyPaused &&
    !screenConsumer.remotelyPaused;

  const remoteControlOnPeer =
    session &&
    session.status === "active" &&
    session.hostPeerId === id;
  const isController =
    remoteControlOnPeer && session.controllerPeerId === meId;
  const showScreenInMini = isMini && remoteControlOnPeer && isController;
  const preferScreenInMini = showScreenInMini && screenVisible;

  return (
    <React.Fragment>
      {!preferScreenInMini &&
        (room.webinar && screenConsumer && !webcamConsumer ? null : (
          <MediaBox hoverable={false} style={style}>
            <PeerInfo
              peer={peer}
              isMe={false}
              isScreen={false}
              displayName={peer.displayName}
              showPeerInfo={true}
              audioScore={micConsumer ? micConsumer.score : null}
              videoScore={webcamConsumer ? webcamConsumer.score : null}
              onFilmStrip={onFilmStrip}
              mini={isMini}
            />

            <VideoView
              peer={peer}
              displayName={peer.displayName}
              videoTrack={webcamConsumer && webcamConsumer.track}
              videoVisible={videoVisible}
            />
          </MediaBox>
        ))}

      {screenConsumer && (!isMini || showScreenInMini) && (
        <MediaBox hoverable={false} style={style} isScreen={true}>
          <PeerInfo
            peer={peer}
            isMe={false}
            isScreen={true}
            displayName={peer.displayName}
            showPeerInfo={true}
            videoScore={screenConsumer ? screenConsumer.score : null}
            onFilmStrip={onFilmStrip}
            mini={isMini}
          />

          <VideoView
            peer={peer}
            videoContain
            displayName={peer.displayName}
            isScreen={true}
            videoTrack={screenConsumer && screenConsumer.track}
            videoVisible={screenVisible}
          />
        </MediaBox>
      )}
    </React.Fragment>
  );
};

SpeakerPeer.propTypes = {
  id: PropTypes.string,
  style: PropTypes.object,
  onFilmStrip: PropTypes.bool,
};

export default SpeakerPeer;
